<script>
  import { Lightbox } from "svelte-lightbox";
  import { onMount } from "svelte";
  import { vratObrazok } from "../../../api/file";
  export let data;

  const fileName = data.image.split("/").pop();
  let lightboxProgrammaticController;

  const port = location.port || (location.protocol === "https:" ? "443" : "80");

  /* onMount(async () => {
    const response = await vratObrazok(data.image, fileName);
    console.log(response);
  }); */
</script>

<Lightbox
  enableFallbackThumbnail={false}
  bind:programmaticController={lightboxProgrammaticController}
  transitionDuration="100"
  enableClickToClose={true}
>
  <span slot="thumbnail">{data.title}</span>
  <img
    src={`${__myapp.env.API_URL}:${port}/${__myapp.env.API_PATH}/api/v1/smartmap/file/${data.image}`}
    alt={data.title}
  />
</Lightbox>

<style lang="scss">
  span {
    cursor: pointer;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
</style>
